export const MESSAGE_MIN = 10;
export const MESSAGE_MAX = 500;
export const RECIPIENT_NAME_MAX = 60;
export const RECIPIENT_EMAIL_MAX = 254;
export const SENDER_EMAIL_MAX = 254;
export const TRAIT_MAX = 200;
export const FORWARD_SLOTS = 3;

export const RATE_LIMIT_WINDOW_SECONDS = 60;
export const RATE_LIMIT_MAX = 5;

export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://kindkudos.app';
